import React, { useEffect, useState } from "react";
import { currencyDecimal, currencyUSD } from "../../helpers/forms/formater";
import DataTableElement from "../../components/elements/DataTableElement";
import GenericCard from "../../components/cards/GenericCard";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../components/form/CustomSelect";
import CustomSearchInput from "../../components/form/CustomSearchInput";
import Columns from "./Columns";
import { categoriesResource, clientsResource, departmentsResource, salesResource, sellersResource } from "../../helpers/configRoutes/backend_helper";
import CustomCalendarRange from "../../components/form/CustomCalendarRange";
import FiltersPagination from "../../components/elements/FiltersPagination";
import { formatCurrencyUsd } from "../../helpers/Formatos";
import CustomButton from "../../components/form/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { update_pagination } from "../../store/pagination/action";

const Sales = () => {
    const { salesPag } = useSelector((state) => state.Pagination.pagination)
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [tableLoad, setTableLoad] = useState({ show: false, textLoad: 'Buscando ventas...' });
    const [loading, setLoading] = useState(false);
    console.log(salesPag)
    const [filters, setFilters] = useState({
        perPage: salesPag.perPage,
        page: salesPag.page,
        seller_id: '',
        client_id: '',
        servicio: '',
        search: salesPag.search,
        date_start: '',
        date_end: '',
        department_id: '',
        category_id: '',
        payment_method: ''
    });

    const [items, setItems] = useState([]);
    const [meta, setMeta] = useState({});
    const [data, setData] = useState({});
    const [dataTotals, setDataTotals] = useState({ products: 0, total_sales: 0 });
    const [clients, setClients] = useState([]);
    const [sellers, setSellers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [departments, seDepartments] = useState([]);
    const [modalPdf, setModalPdf] = useState({ show: false, url: '' })
    const [modalVentasReporte, setModalVentasReporte] = useState({ show: false })
    const [rows, setRows] = useState([])
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        const getItems = async () => {
            const response = await salesResource('get', { params: filters });
            setItems(response.sales);
            setData(response.data)
            console.log(meta)
            setMeta(response.meta)
            setDataTotals(response.dataTotals)

            const productsSnCategory = response.sales
                .filter(pr => !pr.seller_id)
                .map(pr => pr);

            setRows(productsSnCategory);

        };
        getItems();
    }, [filters]);

    useEffect(() => {
        const getCatalogs = async () => {
            const response = await clientsResource('get', { params: { select: true } });
            setClients(response.clients);
            const responseSellers = await sellersResource('get', { params: { select: true } });
            setSellers(responseSellers.sellers);
            const responseCategories = await categoriesResource('get', { params: { select: true } })
            const responseDepartments = await departmentsResource('get', { params: { select: true } })
            setCategories(responseCategories.categories)
            seDepartments(responseDepartments.departments)
        };
        getCatalogs();
    }, []);


    const getReports = async (departments = 0) => {
        filters.departments = departments
        setLoading(true)
        let config = {
            params: filters,
            headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
            responseType: "blob"
        }
        const exportSalidas = await salesResource('get', config)

        const url = URL.createObjectURL(new Blob([exportSalidas]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            'Reporte de ventas.xlsx'
        )
        document.body.appendChild(link)
        link.click()
        setLoading(false)
    }

    const handleUpload = async () => {
        const response = await salesResource('put', { sales: rows, multiple: true }, 1);
        if (response.status) {
            setFilters({ ...filters })
        }
    }

    const cols = Columns(sellers, setFilters, filters, rows, setRows, items, setItems);

    const allRowsHaveCategory = rows.length > 0 && rows.every(r => !!r.seller_id);

    return (
        <div className="flex flex-col w-full p-4 space-y-4">
            {/* Encabezado y botones arriba a la derecha */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                    <h1 className="text-fr-dark text-2xl font-bold">Panel de Ventas</h1>
                    <p className="text-fr-muted text-sm">Consulta y filtra ventas por diferentes criterios</p>
                </div>

                <div className="flex gap-2">
                    <CustomButton
                        loading={loading}
                        textLoad={'Generando reporte...'}
                        onClick={() => getReports(true)}
                        className="flex items-center gap-2 bg-fr-accent text-white px-4 py-2 rounded-lg hover:bg-emerald-600 transition"
                    >
                        <span className="material-symbols-outlined text-base">download</span>
                        Reporte ventas
                    </CustomButton>
                    <CustomButton
                        loading={loading}
                        textLoad={'Generando reporte...'}
                        onClick={() => getReports()}
                        className="flex items-center gap-2 bg-fr-success text-white px-4 py-2 rounded-lg hover:bg-emerald-600 transition"
                    >
                        <span className="material-symbols-outlined text-base">download</span>
                        Reporte General de  Ventas
                    </CustomButton>

                    <CustomButton
                        onClick={() => navigate('/ventas/nueva')}
                        className="flex items-center gap-2 bg-fr-primary text-white px-4 py-2 rounded-lg hover:bg-fr-primary-hover transition"
                    >
                        <span className="material-symbols-outlined text-base">add</span>
                        Nueva Venta
                    </CustomButton>
                </div>
            </div>

            {/* Cards de métricas */}
            <div className="flex flex-wrap gap-4">
                <div className="flex-1 min-w-[200px]">
                    <GenericCard name="Ventas total" text={currencyUSD(data.total || 0)} />
                </div>
                <div className="flex-1 min-w-[200px]">
                    <GenericCard name="Ventas mes actual" text={currencyUSD(data.mes || 0)} />
                </div>
                <div className="flex-1 min-w-[200px]">
                    <GenericCard name="Ventas promedio por vendedor mes actual" text={currencyUSD(data.seller_prom || 0)} />
                </div>
            </div>
            <div className="bg-fr-light border border-fr-muted rounded-lg shadow-md p-4">
                <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">

                    {/* Filtros */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 w-full">
                        <div className="min-w-0">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Vendedor"
                                options={sellers}
                                value={filters.seller_id}
                                handleChange={(e) => setFilters({ ...filters, seller_id: e.target.value })}
                            />
                        </div>

                        <div className="min-w-0">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Cliente"
                                options={clients}
                                value={filters.client_id}
                                handleChange={(e) => setFilters({ ...filters, client_id: e.target.value })}
                            />
                        </div>

                        <div className="min-w-0">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Área"
                                options={categories}
                                value={filters.category_id}
                                handleChange={(e) => setFilters({ ...filters, category_id: e.target.value })}
                            />
                        </div>

                        <div className="min-w-0">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Departamento"
                                options={departments}
                                value={filters.department_id}
                                handleChange={(e) => setFilters({ ...filters, department_id: e.target.value })}
                            />
                        </div>

                        <div className="min-w-0">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Condiciones de pago"
                                options={[{ id: 1, name: 'PUE' }, { id: 2, name: 'PPD' }]}
                                value={filters.payment_method}
                                handleChange={(e) => setFilters({ ...filters, payment_method: e.target.value })}
                            />
                        </div>

                        <div className="min-w-0">
                            <CustomCalendarRange
                                isClearable={true}
                                className="text-sm"
                                holder="Fechas Rango"
                                valueStart={filters.date_start}
                                valueEnd={filters.date_end}
                                filters={filters}
                                setFilters={setFilters}
                            />
                        </div>
                    </div>

                    {/* Input de búsqueda */}
                    <div className="w-full lg:w-[300px]">
                        <CustomSearchInput
                            value={filters.search}
                            handleChange={(e) => setFilters({ ...filters, search: e.target.value })}
                            placeholder="Buscar..."
                        />
                    </div>
                </div>
            </div>



            {/* Tabla */}
            <div className="sticky bottom-0 bg-fr-light border-t border-fr-muted px-6 py-4 flex justify-end gap-12 text-fr-dark font-semibold shadow-inner z-10">
                <div className="text-sm">
                    <span className="mr-2 text-fr-dark/70">Cantidad Productos:</span>
                    {currencyDecimal(dataTotals.products)}
                </div>
                <div className="text-sm">
                    <span className="mr-2 text-fr-dark/70">Importe Total:</span>
                    {formatCurrencyUsd(dataTotals.total_sales)}
                </div>
            </div>
            <FiltersPagination meta={meta} filters={filters} setFilters={setFilters} showFilters={false} readuxPag={true}>
                <DataTableElement columns={cols} tableLoad={tableLoad} items={items} />
            </FiltersPagination>

            {rows.length > 0 && (
                <button
                    onClick={handleUpload}
                    disabled={!allRowsHaveCategory || loader}
                    className={`fixed bottom-14 right-6 z-50 rounded-full w-16 h-16 flex items-center justify-center shadow-xl transition transform hover:scale-105
                        ${allRowsHaveCategory
                            ? 'bg-fr-primary text-white hover:bg-fr-primary-hover'
                            : 'bg-red-500 text-white opacity-70 cursor-not-allowed'
                        }`
                    }
                    title={
                        allRowsHaveCategory
                            ? "Guardar venta"
                            : "Debes asignar un área a todos los productos"
                    }
                >
                    {loader ? (
                        <span className="animate-spin material-symbols-outlined text-[24px]">sync</span>
                    ) : (
                        <span className="material-symbols-outlined text-[28px]">save</span>
                    )}
                </button>
            )}
        </div>
    );
};

export default Sales;
